















import SimpleList from "@/components/generic/SimpleList.vue";
import { DocumentField, FieldType } from "@infoland/iprova-api";
import { ZenyaDialogComponent } from "../../dialogs/ZenyaDialog.vue";
import FrameworksField from "./fields/FrameworksField.vue";
import LinkedDocumentsField from "./fields/LinkedDocumentsField.vue";
import GeneralField from "./fields/GeneralField.vue";
import Shared from "../../../shared";

export default ZenyaDialogComponent.extend({
    name: "DocumentDetails",
    components: { SimpleList, FrameworksField, LinkedDocumentsField, GeneralField },
    props: {
        documentFields: Array as () => DocumentField[]
    },
    data: function () {
        return {
            sortedDocumentFields: [] as DocumentField[],
            fieldType: FieldType
        };
    },
    computed: {},
    methods: {},
    watch: {
        documentFields: {
            handler(newValue: DocumentField[]) {
                let unsortedDocumentFields = newValue;
                unsortedDocumentFields.forEach(f => {
                    if (f.field_type.type === this.fieldType.formatted_text) {
                        f.values[0].value = f.values[0].value.replace(/href=".*?hyperlinkloader.aspx\?hyperlinkid=(.{36})"([^>]*>)/gi, function (
                            match,
                            $1,
                            $2
                        ) {
                            return '<a href="' + Shared.iProvaUrl + `/HyperlinkLoader.aspx?HyperlinkID=${$1}&new=1` + '" target="_blank">';
                        });

                        f.values[0].value = f.values[0].value.replace(/href=".*?#\/hyperlink\/(.{36})"([^>]*>)/gi, function (match, $1, $2) {
                            return '<a href="' + Shared.iProvaUrl + `/HyperlinkLoader.aspx?HyperlinkID=${$1}&new=1` + '" target="_blank">';
                        });
                    }
                });
                let systemFields: DocumentField[] = unsortedDocumentFields.filter(f => f.field_id < 100);
                let customFields: DocumentField[] = unsortedDocumentFields.filter(f => f.field_id > 99);
                systemFields.sort((a, b) => a.name.localeCompare(b.name));
                customFields.sort((a, b) => a.name.localeCompare(b.name));
                this.sortedDocumentFields.push(...systemFields);
                this.sortedDocumentFields.push(...customFields);
            },
            immediate: true
        }
    }
});
